(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.persona')
    .factory('PersonaFactory', PersonaFactory);

  function PersonaFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'persones';
    var PersonaBase = {
      getAll: function(form){
        var url = api;
        return DataFactory.getWithParams(url, form);
      },

      get: function(id){
        var url = api + '/' + id;
        return DataFactory.get(url);
      },

      getByUserName: function(id){
        var url = api + '/getByUserName?idUserName=' + id;
        return DataFactory.get(url);
      },

      add: function(obj){
        return DataFactory.add(api,obj);
      },

      update: function(id, obj){
        var url = api + '/' + id;
        return DataFactory.update(url,obj);
      },

      delete: function(id){
        var url = api;
        return DataFactory.delete(url, id);
      },

      getOperacions: function(id, form){
        var url = api + '/' + id + '/operacions';
        return DataFactory.getWithParams(url, form);
      },

      getPersonaEspais: function(id, form){
        var url = api + '/' + id + '/persona_espais';
        return DataFactory.getWithParams(url, form);
      },

      getPersonesNoAssociades: function(id){
        var url = api + '/' + id + '/persona_espais/no_associades';
        return DataFactory.get(url);
      },

      addPersonaEspais: function(id, form){
        var url = api + '/' + id + '/persona_espais';
        return DataFactory.add(url, form);
      },

      updatePersonaEspais: function(id, form){
        var url = api + '/' + id + '/persona_espais';
        return DataFactory.update(url, form);
      },

      deletePersonaEspai: function(id, idPersonaEspai, recursiu){
        var url = api + '/' + id + '/persona_espais/' + idPersonaEspai;
        return DataFactory.deleteWithParams(url, {recursiu: recursiu});
      },
    };
    return PersonaBase;
  }
}());
